import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    List,
    ListItem,
    ListItemText,
    Button,
    InputAdornment
} from '@material-ui/core';
import { Search } from '@material-ui/icons';

const QuotePageModalItens = ({
    open,
    onClose,
    searchTerm,
    onSearchChange,
    filteredItems,
    onSelectItem,
    formatCurrency,
    classes = {},
    currentLanguage
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                {currentLanguage.bepiService.workshop.workshop_quote_modal_items_title}
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label={currentLanguage.bepiService.workshop.workshop_quote_modal_search_label}
                    placeholder={currentLanguage.bepiService.workshop.workshop_quote_modal_search_placeholder}
                    value={searchTerm}
                    onChange={onSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        ),
                    }}
                />

                <List style={{ maxHeight: 300, overflow: 'auto' }}>
                    {filteredItems.map(item => (
                        <ListItem
                            key={item.id}
                            button
                            onClick={() => onSelectItem(item)}
                        >
                            <ListItemText
                                primary={`${item.codigo_interno} - ${item.nome}`}
                                secondary={`${formatCurrency(item.valor)} • ${item.tipo_item === 'peca' ? currentLanguage.bepiService.workshop.workshop_quote_item_type_part : currentLanguage.bepiService.workshop.workshop_quote_item_type_service}`}
                            />
                        </ListItem>
                    ))}
                    {filteredItems.length === 0 && (
                        <ListItem>
                            <ListItemText
                                primary={currentLanguage.bepiService.workshop.workshop_quote_modal_no_items}
                                style={{ textAlign: 'center' }}
                            />
                        </ListItem>
                    )}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {currentLanguage.bepiService.shared.shared_details_close_btn}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default QuotePageModalItens;
